<template>
    <div class="relative h-6" :class="handleParentDivWidth">
        <div
                v-for="(member, index) in members"
                :key="member.uid"
                class="absolute top-0 left-0 h-6 w-6"
                :class="positionElementHorizontally(index)"
        >
            <Avatar :firstName="member.first_name" :avatar="member.avatar" hasWhiteOutline />
        </div>
        <div
                v-if="totalMembers > 3 || totalMembers === 0"
                class="bg-semitone-primary-1 border leading-0 absolute top-0 left-0 z-30 h-6 min-w-[24px] rounded-full ring-4 ring-white flex justify-center items-center"
                :class="[totalMembers > 0 ? 'translate-x-[66px]' : 'translate-x-[35px]']"
        >
            <p class="text-tag text-default-1 font-normal text-center w-full mt-0.5">
                {{ formattedMembersCount }}
            </p>
        </div>
    </div>
</template>

<script setup>
import Avatar from "@/components/custom/Avatar.vue";
import {computed} from "vue";

const props = defineProps({
    members: {
        type: Array,
        required: true
    },
    totalMembers: {
        type: Number,
        required: true
    },
})

const formattedMembersCount = computed(() => {
    const plusCharacter = props.totalMembers > 3 ? '+' : '';
    return props.totalMembers > 3 ? `${plusCharacter}${parseInt(props.totalMembers) - 3}` : `${plusCharacter}${parseInt(props.totalMembers)}`;
});

function positionElementHorizontally(index) {
    const classes = ['translate-x-[0px] z-[1]', 'translate-x-[22px] z-[2]', 'translate-x-[44px] z-[3]'];
    return classes[index];
}

const handleParentDivWidth = computed(() => {
    const widths = ['min-w-[25px]', 'min-w-[50px]', 'min-w-[70px]', 'min-w-[90px]'];
    switch(props.totalMembers) {
    case 1:
        return widths[0];
    case 2:
        return widths[1];
    case 3:
        return widths[2];
    default:
        return widths[3];
    }
});
</script>